import { render, staticRenderFns } from "./AddClausulaservicoPage.vue?vue&type=template&id=0a3737e6"
import script from "./AddClausulaservicoPage.vue?vue&type=script&lang=js"
export * from "./AddClausulaservicoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports